module.exports = function() {
  return new Worker(__webpack_public_path__ + "91d28b160c78cbf228ea.worker.js");
};